module.exports = __webpack_public_path__ + "img/1527062252.caad4659.jpg";